import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

const UserAnalyticsHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <h3>User Analytics</h3>
      <p>
        Usage of the assistant over a window you choose: how many people asked
        questions, how many questions they asked, how many tokens that consumed,
        and what it is estimated to have cost.
      </p>
    </Box>
    <Box>
      <h3>How the figures are counted</h3>
      <ul>
        <li>
          An <strong>active user</strong> asked at least one question. Someone
          who opened the app without asking anything is not counted as active,
          though their connection still counts towards sessions.
        </li>
        <li>
          A <strong>session</strong> is one connection, measured from opening the
          app to closing it, and is credited to the day it started.
        </li>
        <li>
          Days are <strong>UTC</strong> days, so they do not line up with your
          local midnight.
        </li>
        <li>
          A window includes today, so &quot;Last 7 days&quot; means today plus
          the six days before it.
        </li>
      </ul>
    </Box>
    <Box>
      <h3>Reading the cost</h3>
      <ul>
        <li>
          Cost is an <strong>estimate</strong> from published per-token rates,
          not billed spend.
        </li>
        <li>
          A model with no configured rate is shown as unpriced rather than as
          zero. When that happens the total says it excludes those models, and
          names them, so it understates real spend by that amount.
        </li>
        <li>
          Rates are the standard on-demand ones. Discounted and premium tiers
          exist — batch, and routing that stays within one region — so a figure
          can be out by roughly the size of those differences in either
          direction.
        </li>
        <li>
          Prompt caching is not modelled: cached input is priced as ordinary
          input, which costs more than a cache hit really does.
        </li>
      </ul>
    </Box>
    <Box>
      <h3>Blanks and dashes</h3>
      <ul>
        <li>
          A dash means there is no figure to show, which is not the same as zero
          — an average session with no completed session to measure, for
          instance.
        </li>
        <li>
          Comparisons with the previous period are omitted when there is no
          previous period to compare against.
        </li>
        <li>
          All-time totals carry no day-by-day breakdown, so the trend is only
          available for a fixed window.
        </li>
      </ul>
    </Box>
    <Box>
      <h3>Coverage</h3>
      <p>
        Tracking began when this feature was deployed. Activity from before then
        was never recorded, so longer windows are complete only from that date
        onwards.
      </p>
    </Box>
  </SpaceBetween>
);

export default UserAnalyticsHelpPanel;
